import React from 'react';
import { Box, Typography } from '@material-ui/core';

const UsernameIconContainer = ({ icon, text, showDivider = false }) => {
  return (
    <Box style={{ 
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      position: 'relative',
    }}>
      <Box style={{ 
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}>
        {icon}
      </Box>
      {showDivider && (
        <Box style={{
          position: 'absolute',
          width: '1px',
          height: '150px',
          top: '25px',
          left: '8px',
          backgroundColor: '#CDD4E3',
          zIndex: 0,
        }} />
      )}
      <Typography style={{
        color: 'var(--Navy---navy-main, #061E44)',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '24px',
        letterSpacing: '0.32px',
      }}>
        {text}
      </Typography>
    </Box>
  );
};

export default UsernameIconContainer;

